/**
 * Created by Nisarg on 7/24/2017.
 */
import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import Login from '../Pages/Login';
import createHistory from 'history/createBrowserHistory';
import firebase from 'firebase';
import _HauteFire from '../Utils/HauteFire';
const HauteFire = new _HauteFire();
const history = createHistory();

export default class EnsureLoggedInContainer extends Component {
    constructor() {
        super();

        this.state = {isAuth: false}
    }

    componentWillMount() {
        console.log(this.props.children);
        const _this = this;
        debugger;

        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                _this.setState({isAuth: true})
            }
        })
    }

    renderAuth() {
        if (this.state.isAuth) {
            return this.props.children;
            // return <Redirect to="/dashboard"/>;
        }
        else {
            this.props.history.push('/login');
            // return <Redirect to="/login"/>;
            // return null;
        }
    }

    render() {
        return (this.renderAuth.bind(this))
    }
}



// WEBPACK FOOTER //
// ./src/views/EnsureLoggedInContainer/EnsureLoggedInContainer.js